import * as Yup from 'yup'

const ProductBrandUpdateSchema = Yup.object().shape({
  label           : Yup.string().required('Required'),
  url             : Yup.string().required('Required'),
  classifications : Yup.string().required('Required')
})

export default ProductBrandUpdateSchema